// scripts/components.jsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import { PrimaryNav, GlobalFooter } from '@hagerty/global-navigation';

const loginAction = (event) => {
    event.preventDefault(); // override the link behavior
    window.location.href = "/authenticate/login"
};

const logoutAction = (event) => {
    event.preventDefault(); // override the link behavior
    window.location.href = "/authenticate/logout"
};

const checkAuth = async () => {
    try {
        // If response is a redirect, we don't want to follow the redirect since it will fail on a CORS
        // error from a JS request anyway. We want to return null to render the unauthenticated
        // version of the header
        const response = await fetch('/authenticate/userauth', { redirect: "manual" })
        if (!response.ok) {
            return null;
        }

        const userAuth = await response.json();
        if (!userAuth) {
            console.error('Authenticated user was null');
            return null;
        }

        const user = {
            sub: userAuth.Sub // required as unique identifier
        }

        if ((userAuth.GivenName != " ") && (userAuth.FamilyName != " ")) {
            user.given_name = userAuth.GivenName; // optional
            user.family_name = userAuth.FamilyName; // optional
        }

        return user;
    } catch (error) {
        console.error('Error checking authentication:', error);
        return null;
    }
};

// Function to fetch data from the APIs
async function fetchData() {
    try {
        // see country.config.js and webpack.config.js for modifying the transpiled .js files around this GLOBAL_NAV_COUNTRY placeholder
        const navResponse = await fetch(`https://${ENV}api.hagerty.com/gns/v1/navigation/${GLOBAL_NAV_COUNTRY}direct`);

        var dataDict = new Object();
        dataDict["nav"] = await navResponse.json();
        return dataDict;
    } catch (error) {
        console.error('Error fetching navigation data:', error);
        return null;
    }
}

const headerPlaceholder = document.getElementById('hagerty-header');
const footerPlaceholder = document.getElementById('hagerty-footer');

// Check if the header and footer placeholders exist
if (headerPlaceholder || footerPlaceholder) {
    // Fetch the navigation data and render the header and footer components
    fetchData().then((dataDict) => {
        // Destructure the navigation data to get the header and footer data
        const { header = null, footer = null } = dataDict["nav"];

        // Create a root for the header and footer components and render them
        if (headerPlaceholder) {
            // The user profile dropdown menu typically ignores clicks/touches when itself is clicked,
            // but shadowDOM event retargeting causes the event target to be the "light" DOM container
            // So we need to stopPropagation, but not preventDefault, at the shadow root to allow links
            // to be clicked without dismissing the menu. Clicks outside the header continue to trigger the
            // event listener as expected.
            headerPlaceholder.shadowRoot.addEventListener("mousedown", (e) => e.stopPropagation(), { passive: true });
            headerPlaceholder.shadowRoot.addEventListener("touchstart", (e) => e.stopPropagation(), { passive: true });

            // Render in the placeholder's shadowroot. Styles are pre-loaded in Direct.Master for faster performance
            const headerRoot = createRoot(headerPlaceholder.shadowRoot);
            headerRoot.render(
                <PrimaryNav
                    logo='2026'
                    dataApi={header}
                    authCheckFn={checkAuth}
                    loginAction={loginAction}
                    logoutAction={logoutAction}
                />);
        }

        if (footerPlaceholder) {
            const footerRoot = createRoot(footerPlaceholder.shadowRoot);
            footerRoot.render(<GlobalFooter dataApi={footer} showCCPA />);
        }
    });
}
